"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orderTagApi = _interopRequireWildcard(require("@/api/orderTagApi.js"));
var _validate = require("@/utils/validate");
var _store = require("@/api/store");
var categoryServiceApi = _interopRequireWildcard(require("@/api/categoryApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      visible: false,
      cateOptions: [],
      pram: {},
      initloading: false
    };
  },
  mounted: function mounted() {
    this.pram = {};
  },
  methods: {
    openInit: function openInit() {
      var _this = this;
      var details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = details || {},
        id = _ref.id;
      this.getAllCate();
      this.pram = _objectSpread({}, details);
      categoryServiceApi.jdBindDetail({
        categoryId: id
      }).then(function (res) {
        _this.pram = _objectSpread(_objectSpread({}, details), {}, {
          showCategoryIds: res ? JSON.parse(res) : []
        });
      });
    },
    handerSubmit: (0, _validate.Debounce)(function () {
      var _this2 = this;
      this.loading = true;
      var _this$pram = this.pram,
        id = _this$pram.id,
        showCategoryIds = _this$pram.showCategoryIds;
      categoryServiceApi.jdBindCate({
        categoryId: id,
        showCategoryIds: JSON.stringify(showCategoryIds)
      }).then(function (data) {
        _this2.$message.success('操作成功');
        _this2.loading = false;
        _this2.visible = false;
        _this2.$emit('doRefresh');
      }).catch(function () {
        _this2.loading = false;
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    getAllCate: function getAllCate() {
      var _this3 = this;
      this.visible = true;
      this.initloading = true;
      this.cateOptions = [];
      (0, _store.categoryApi)({
        status: -1,
        type: 8
      }).then(function (res) {
        _this3.cateOptions = _this3.addDisabled(res);
        _this3.initloading = false;
      }).catch(function (err) {
        _this3.initloading = false;
      });
    },
    // 限制商品分类只能选择开启的
    addDisabled: function addDisabled() {
      var _this4 = this;
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var list = [];
      arr && arr.length && arr.forEach(function (e, index) {
        var e_new = _objectSpread(_objectSpread({}, e), {}, {
          disabled: !e.status
        });
        if (e.child) {
          var childList = _this4.addDisabled(e.child);
          e_new = _objectSpread(_objectSpread({}, e_new), {}, {
            child: childList
          });
        }
        list.push(e_new);
      });
      return list;
    }
  }
};